<template>
  <div class="musicbox-item">
    <div class="musicbox-item__header">
      <span class="name">{{ deviceData.name }}</span>
      <span v-show="online" class="link">
        <span class="text" @click="toMonitor">详情</span>
        <span class="iconfont icon-dakai" @click="openNewWindow"></span>
      </span>
    </div>
    <ModState :data="deviceData" />
    <DeviceDetail :data="deviceData" />
  </div>
</template>

<script>
import ModState from './mod-state';
import DeviceDetail from './device-detail';
import { windowOpen } from '@/utils/utils';

export default {
  props: {
    sn: String,
    deviceData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  components: {
    DeviceDetail,
    ModState
  },
  computed: {
    deviceType() {
      return this.deviceData.deviceType;
    },
    online() {
      return this.deviceData.runstate > 0;
    }
  },
  methods: {
    toMonitor() {
      this.$router.push({
        name: 'Realdata',
        params: {
          sn: this.sn,
          deviceType: this.deviceType
        }
      });
    },
    openNewWindow() {
      windowOpen(
        {
          name: 'Realdata',
          params: {
            sn: this.sn,
            deviceType: this.deviceType
          }
        },
        this.sn
      );
    }
  }
};
</script>

<style lang="scss">
.musicbox-item {
  height: 100%;
  padding-bottom: 5px;
  background: #172128;
  position: relative;
  overflow: hidden;
  &__header {
    display: flex;
    justify-content: space-between;
    color: $primary-text-color;
    font-size: 18px;
    background: #183449;
    padding: 8px 10px;
    margin-bottom: 15px;
    .link {
      // text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
